<template>
	<div style="display:inline-block;">
		<div class="btn-group" style="min-width:100%;" v-if="municipe">
			<button type="button" class="btn btn-info btn-block dropdown-toggle" data-toggle="dropdown">
				<i class="fa fa-user"></i>
				{{ nome.toUpperCase() }}
				<i class="fa fa-caret-down"></i>
			</button>
			<ul class="dropdown-menu" style="min-width:100%;">
				<router-link to="/cadastro" tag="li">
					<a style="padding: 6px 12px;"><i class="fa fa-edit"></i> MEU CADASTRO</a>
				</router-link>
				<router-link to="/agendamentos" tag="li">
					<a style="padding: 6px 12px;"><i class="fa fa-calendar"></i> MEUS AGENDAMENTOS</a>
				</router-link>
				<li>
					<a href="#" style="padding: 6px 12px;color:tomato;" @click.prevent="logout">
						<i class="fa fa-sign-out"></i> SAIR
					</a>
				</li>
			</ul>
		</div>
		<div v-else>
			<router-link to="/login" class="btn btn-info" style="min-width:100%;">
				<i class="fa fa-lock"></i> LOGIN
			</router-link>
		</div>
	</div>
</template>

<script>
	import Municipe from 'models/municipe';

	export default {
		data() {
			return {
				municipe: '',
				nome: ''
			};
		},

		async created() {
			try {
				this.municipe = await Municipe.getCurrent();

				this.nome = this.municipe.nome.split(' ')[0];
			} catch(e) {}
		},

		methods: {
			logout() {
				Municipe.logout().then(() => {
					this.$router.push('/');
					location.reload();
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// loggedUser.vue?f43494e4